module.exports = __webpack_public_path__ + "img/delete_account.07e1d23f.svg";